import React, { useState, useRef } from "react";

// react-bootstrap components
import { Form, Row, Alert, Col, Spinner, Button } from "react-bootstrap";
import SimpleReactValidator from 'simple-react-validator';
import { setAlert } from 'action/index.js';
import API from "api.js";
import { setUser } from 'action/index.js';
import { store } from 'store/index';
import { connect } from 'react-redux';
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => dispatch(setUser(user))
  };
};

const Password = (props) => {
  const [email] = useState(store.getState().user.email);
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [errorBag, setErrorBag] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [, forceUpdate] = useState();

  const validatorRef = useRef(
    new SimpleReactValidator({
      validators: {
        strongPassword: {
          message: "Password must be at least 6 characters and include 1 uppercase letter, 1 number, and 1 special character",
          rule: (val) => {
            if (!val || typeof val !== "string") return false;
            const hasLength = val.length >= 6;
            const hasUpper = /[A-Z]/.test(val);
            const hasNumber = /\d/.test(val);
            const hasSpecial = /[^A-Za-z0-9]/.test(val);
            return hasLength && hasUpper && hasNumber && hasSpecial;
          },
          required: true,
        },
      },
    })
  );

  const validator = validatorRef.current;

  const changeInput = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'otp':
        setOtp(value);
        break;
      case 'password':
        setPassword(value);
        break;
      case 'password_confirmation':
        setPasswordConfirmation(value);
        break;
      default:
        break;
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const postSignUp = async (e) => {
    e.preventDefault();

    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return false;
    }

    setErrorBag(null);
    setIsSaveLoading(true);

    var bodyFormData = new FormData();
    bodyFormData.set('otp', otp);
    bodyFormData.set('password', password);
    bodyFormData.set('password_confirmation', passwordConfirmation);
    
    let res = null;
    try {
      res = await API({
        method: 'POST',
        url: '/changePassword',
        data: bodyFormData
      });
    } catch (error) {
      console.error(error);
      res = error.response;
      setIsSaveLoading(false);
      // return;
    }

    setIsSaveLoading(false);
    console.log(res);
    
    if (res?.status === 200) {
      store.dispatch(setAlert({ 'flag': true, 'type': 1, 'message': "Password changed successfully!" }));
      setOtp('');
      setPassword('');
      setPasswordConfirmation('');
      setErrorBag(null);
      setPasswordVisible(false);
      setConfirmPasswordVisible(false);
      validator.hideMessages();
      forceUpdate({});
    } else if (res?.status === 409) {
      setErrorBag("OTP is either invalid or expired!");
    } else if (res?.status === 422) {
      setErrorBag(res.data.message);
    }
  };

  const sendOTP = async (e) => {
    e.preventDefault();
    
    setErrorBag(null);
    setIsOtpLoading(true);

    var bodyFormData = new FormData();
    bodyFormData.set('email', email);
    
    let res = null;
    try {
      res = await API({
        method: 'POST',
        url: '/requestotp',
        data: bodyFormData
      });
    } catch (error) {
      console.error(error);
      setIsOtpLoading(false);
      // return;
    }

    setIsOtpLoading(false);

    if (res?.status === 200) {
      setErrorBag("Verification code has been sent to your email.");
    } else if (res?.response?.status === 422) {
      let str = '';
      Object.values(res?.response?.data?.errors).forEach((val) => { 
        str += val[0] + '\n'; 
      });
      setErrorBag(str);
    } else if (res?.response?.status === 402) {
      setErrorBag("Wrong credentials.");
    }
  };

  return (
    <>
      <div className="content p-0 w-100">
        <DashboardHeader title="Change Password" />
        <div className="pmw contact-page outer-wrapper">
          <Col className="profile-content p-0">
            <div>
              {errorBag &&
                <Alert variant="warning">{errorBag}</Alert>
              }

              <div className="left-btns mt-4">
                <Button
                  className="outline-btn"
                  onClick={(e) => { 
                    if (!isOtpLoading) {
                      sendOTP(e);
                    }
                  }}
                  style={{ 
                    marginLeft: "0px",
                    pointerEvents: isOtpLoading ? 'none' : 'auto',
                    opacity: isOtpLoading ? 0.7 : 1
                  }}
                  disabled={isOtpLoading}
                >
                  {isOtpLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Sending...
                    </>
                  ) : (
                    "Request a verification code on your mail!"
                  )}
                </Button>
              </div>

              <Form className="mt-4">
                <Row>
                  <Col className="" md="7">
                    <Form.Group className="mb-3">
                      <Form.Label>Verification Code</Form.Label>
                      <Form.Control
                        value={otp}
                        name="otp"
                        placeholder="Verification Code"
                        type="text"
                        onChange={(e) => { changeInput(e) }}
                      />
                      {validator.message('verification code', otp, 'required')}
                    </Form.Group>
                  </Col>
                  <Col className="" md="7">
                    <Form.Group className="mb-3">
                      <Form.Label>New Password</Form.Label>
                      <div className="password-field">
                        <Form.Control
                          value={password}
                          name="password"
                          placeholder="New Password"
                          type={passwordVisible ? "text" : "password"}
                          onChange={(e) => { changeInput(e) }}
                          autoComplete="new-password"
                        />
                        <button
                          type="button"
                          className="password-toggle"
                          aria-label={passwordVisible ? "Hide password" : "Show password"}
                          aria-pressed={passwordVisible}
                          disabled={!password}
                          onClick={togglePasswordVisibility}
                        >
                          <i
                            className={`fa ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      {validator.message('new password', password, 'strongPassword')}
                    </Form.Group>
                  </Col>
                  <Col className="" md="7">
                    <Form.Group className="mb-3">
                      <Form.Label>Confirm Password</Form.Label>
                      <div className="password-field">
                        <Form.Control
                          value={passwordConfirmation}
                          name="password_confirmation"
                          placeholder="Confirm Password"
                          type={confirmPasswordVisible ? "text" : "password"}
                          onChange={(e) => { changeInput(e) }}
                          autoComplete="new-password"
                        />
                        <button
                          type="button"
                          className="password-toggle"
                          aria-label={confirmPasswordVisible ? "Hide password" : "Show password"}
                          aria-pressed={confirmPasswordVisible}
                          disabled={!passwordConfirmation}
                          onClick={toggleConfirmPasswordVisibility}
                        >
                          <i
                            className={`fa ${confirmPasswordVisible ? "fa-eye-slash" : "fa-eye"}`}
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      {validator.message('confirm password', passwordConfirmation, `required|in:${password}`, { messages: { in: 'Passwords need to match!' } })}
                    </Form.Group>
                  </Col>
                </Row>
              </Form>

              <Button
                className="outline-btn"
                onClick={postSignUp}
                disabled={isSaveLoading}
                style={{
                  pointerEvents: isSaveLoading ? 'none' : 'auto',
                  opacity: isSaveLoading ? 0.7 : 1
                }}
              >
                {isSaveLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Col>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Password);